module.exports = __webpack_public_path__ + "img/form3.187bd50e.jpg";